'use strict'

import css from './windowed.styles.scss'
import template from './windowed.template.pug'

export class WindowedController {
  constructor() {
    'ngInject'
    Object.assign(this, {})
  }
}

export const umsWindowed = {
  template: template({ css }),
  transclude: true,
  controller: WindowedController,
}



// WEBPACK FOOTER //
// ./app/account/components/windowed/windowed.component.js